// extracted by mini-css-extract-plugin
export default {"input":"Input_input__E9+jp","errorInput":"Input_errorInput__ymkat"};